export const app_url = process.env.REACT_APP_APPLICATION_URL || "https://claritycooperative.com/";
export const base_url = process.env.REACT_APP_BASE_URL || "https://api.claritycooperative.com/api/";
export const community_url = process.env.REACT_APP_COMMUNITY_URL || "https://community.claritycooperative.com/";
export const grammerly_client_id = process.env.REACT_APP_GRAMMERLY_CLIENT_ID;
export const domain_url = "https://claritycooperative.com";
export const app_domain_url = "https://claritydev.topsdemo.org/storage/";
export const documentFontFamily = "NeuzeitGro-Reg";
